
/* Developed by Priya P */

import { Component, OnInit, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Message, ConfirmationService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { EditPopup } from '../.././shared/edit-popup';
import { SharedService } from '../.././shared/shared.service';
import { BaseComponent } from '../.././shared/base.component';
import { FPMessage, Severities, RoleAccess,ContractType, SaveContractType } from '../.././shared/shared.model';
import { CapitalizeFirstPipe } from '../.././shared/pipes/custom-pipes.pipe';


@Component({

    selector: 'contract-type-add-edit',
    templateUrl: 'contract-type-add-edit.component.html'
})

export class ContractTypeAddEditComponent extends BaseComponent implements OnInit, EditPopup {
    @Input() header: string;
    @Input() contracttypeId: number;
    @Input() ContractType: ContractType;
    @Input() contracttypeName: string;
    @Output() done = new EventEmitter();

    frmContractType: FormGroup;
    SaveContractType: SaveContractType[] = [];
    submitted: boolean = false;
    isVisible: boolean = false;
    saveContractType :string;


    message: FPMessage;
    isEdit: boolean = true;
    brandmasval: number;
    
    constructor(private router: Router, public sharedService: SharedService,
        protected translate: TranslateService, private formBuilder: FormBuilder,
        private confirmationService: ConfirmationService) {
        super(sharedService, translate);

    }

    ngOnInit() {debugger
        this.frmContractType = this.formBuilder.group({
            ContractType: ['', Validators.required],
            Description: ['', Validators.maxLength(1000)],
            IsActive: [0],
        });
        if (this.contracttypeId != 0) {
            
            this.isEdit = (this.contracttypeId != null && this.contracttypeId > 0) ? true : false;
            this.getContract(super.globalInfo().CompanyId, this.contracttypeId);
        }
    } //ngOnInit ends

    getContract(CompanyId: number, ContractTypeId: number) {
         debugger

         
        this.sharedService.getContract(CompanyId, ContractTypeId).subscribe(s => {
            debugger
                this.frmContractType.patchValue({
                   ContractType: s.ContractType,
                    Description: s.Description,
                    IsActive: s.IsActive == 0 ? 1 : 0
                })
            });
    }

    save(SaveContractType: SaveContractType, formValid: boolean) {
        this.submitted = true;

        this.contracttypesave(SaveContractType, formValid);
    }

    contracttypesave(SaveContractType: SaveContractType, formValid: boolean) {
        debugger
         
        if (formValid) {
            SaveContractType.ContractTypeId = this.contracttypeId;
            SaveContractType.CompanyId = super.globalInfo().CompanyId;
            SaveContractType.LastChangedBy = super.globalInfo().LoginId;

            SaveContractType.IsActive = SaveContractType.IsActive == 1 ? 0 : 1;

            if (this.contracttypeId > 0) {
                this.sharedService.updateContractType(SaveContractType).subscribe(s => {debugger
                    this.message = s.Message
                    if(this.contracttypeName == "1")
                    {
                          this.saveContractType = s.Data;
                    }
                    if (s.Message.Severity == Severities.success) this.close(true);
                    else {
                        SaveContractType.IsActive = SaveContractType.IsActive == 1 ? 0 : 1;
                        this.close(false);
                    }
                });
            }
            else {
                 

                SaveContractType.CreatedBy = super.globalInfo().LoginId;
                this.sharedService.insertContractType(SaveContractType).subscribe(s => {
                    debugger
                    this.message = s.Message;
                  if(this.contracttypeName == "1")
                {
                      this.saveContractType = s.Data;
                }

                    if (s.Message.Severity == Severities.success) this.close(true);
                    else {
                        SaveContractType.IsActive = SaveContractType.IsActive == 1 ? 0 : 1;
                        this.close(false);
                    }
                });

            }
        }
    }

    close(success?: boolean) {
        debugger
        if (success || success == false) {
            if (this.message.MessageCode == "1001" || this.message.MessageCode == "1002") {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant('CONTRACTTYPE') + " " + this.translate.instant(this.message.MessageCode)
                });
            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant(this.message.MessageCode)
                });
            }


            if(this.contracttypeName == "1"){
                this.done.emit(this.saveContractType);
            }
            else{
                this.done.emit(success);
            }
            
        }
        else if (success == null || success == undefined)
                
        this.done.emit(null);
                        
          }

}